/** Base hours when a service is primary (override, then duration; primary min 1). */
export function primaryServiceBaseDuration(
  duration: number,
  durationAsPrimary?: number | null,
): number {
  const base = durationAsPrimary ?? duration;
  return base > 0 ? base : 1;
}

/** Slot/overlap APIs: calculated job total, minimum 1 hour. */
export function jobDurationHoursForScheduling(calculatedTotalHours: number): number {
  return calculatedTotalHours > 0 ? calculatedTotalHours : 1;
}
